// Abas por tipo de host, compartilhadas entre a tela de Hosts (/#devices) e a de
// Backups (/#backups). Filtro client-side sobre a lista de api.devices().
import type { Device } from '../api';

// Retificador (RTF): não é equipamento de rede — Huawei ETP* / desc "retificador".
// Não há role dedicado no enum; identificado por hostname prefixo "RTF" (convenção SC),
// model ETP* ou desc. O prefixo cobre retificadores futuros de outros modelos.
export function isRectifier(d: Device): boolean {
  return /^RTF\b/i.test(d.hostname ?? '')
    || /^ETP\d|retific|rectif/i.test(d.model?.code ?? '')
    || /retific|rectif/i.test(d.description ?? '');
}

// Falha de acesso: sem nenhuma credencial cadastrada OU alguma credencial com
// último teste falho (lastTestOk === false). lastTestOk vem do worker test-credentials.
export function hasAccessProblem(d: Device): boolean {
  const acc = ((d as any).accesses ?? []) as Array<{ lastTestOk?: boolean | null }>;
  if (acc.length === 0) return true;
  return acc.some((a) => a.lastTestOk === false);
}

export type DeviceTab = 'all' | 'router' | 'olt' | 'bgp' | 'rtf' | 'fail';
export const DEVICE_TABS: Array<{ key: DeviceTab; label: string }> = [
  { key: 'all', label: 'Todos' },
  { key: 'router', label: 'Roteadores (RTR)' },
  { key: 'olt', label: 'OLTs' },
  { key: 'bgp', label: 'BGP' },
  { key: 'rtf', label: 'Retificadores (RTF)' },
  { key: 'fail', label: 'Falha de acesso' }
];

export function matchDeviceTab(d: Device, tab: DeviceTab): boolean {
  switch (tab) {
    case 'olt': return d.role === 'OLT';
    case 'rtf': return isRectifier(d);
    case 'router': return d.role === 'ROUTER' && !isRectifier(d);
    case 'bgp': return !!d.bgpEnabled;
    case 'fail': return hasAccessProblem(d);
    default: return true;
  }
}
